
import { useEffect, useState } from "react";
import { Button, Card, Grid, Typography, TextField, Box, Switch, Backdrop, CircularProgress, Modal, FormControl } from "@mui/material"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import InfoIcon from '@mui/icons-material/Info';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import axios from 'axios';
import DownloadIcon from '@mui/icons-material/Download';

import { MultiDropDown } from "./MultiDropDown";
import FileUploadField from "./FileUploadField";
import { fetchAPI } from "../../utils/ApiService";
import { icons, cardHeader, buttonStyle, iconStyle, cardStyle, butttonWithIcon, secondary_icon, modalstyle } from "../../styles/sharedStyles";
import { UploadFileDetails } from "./UploadFileDetails";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import React from 'react';
import { CustomizedSnackbar } from "../../utils/CustomizedSnackbar";

export const CreateFormulation = forwardRef((props, ref) => {

    const grandchildRef = React.useRef();

    const [file, setFile] = useState([]);

    const [problemName, setProblemName] = useState("");
    const [EDA, setEDA] = useState(false);
    const [key, setKey] = useState([]);
    const [fileProcessCompleted, setFileProcessCompleted] = useState(false);
    const [targetVariables, setTargetVariables] = useState([]);
    const [loadopen, setLoadpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const [columnCount, setColumnCount] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [droppedColumnsData, setDroppedColumnsData] = useState([])
    const [isEDAReportAvailable, setIsEDAReportAvailable] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("success");
    const [errorField, setErrorField] = useState("");
    const [eda_report_msg, setEda_report_msg] = useState("");

    useImperativeHandle(ref, () => ({
        clearData() {
            setFile([]);
            setProblemName("");
            setEDA(false);
            setFileProcessCompleted(false);
            setTargetVariables([]);
            setColumnCount(0);
            setRowCount(0);
            setDroppedColumnsData([]);
            setIsEDAReportAvailable(false);
            setEda_report_msg("")

            console.log("child component")
            grandchildRef.current?.grandchildFunction();

        }

    }));

    useEffect(() => {
    if (file.length === 0) {
        setFileProcessCompleted(false);
        setTargetVariables([]);
        setColumnCount(0);
        setRowCount(0);
        setDroppedColumnsData([]);
        setIsEDAReportAvailable(false);
        setKey([]);
        setEda_report_msg("")
        
        if (grandchildRef.current?.grandchildFunction) {
            grandchildRef.current.grandchildFunction();
        }
    }
}, [file]);

    const handleFileUpload = async (key_values) => {
        setLoadpen(true)
        setSnackbarOpen(false)
        try {
            const formData = new FormData();
            formData.append("problem_name", problemName);
            let gEDA = EDA ? "Yes" : "No";
            formData.append("generateEDA", gEDA);

            const data = {
                "problemname": problemName,
                "generateEDA": gEDA,
                "key": key_values
            }

            const response = await fetchAPI.post("/process_upload_file", data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            if (response.status === 202 || response.status === 200) {

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/upload_stats", { problemName }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status == 200) {
                            setFileProcessCompleted(true);
                            if (statusResponse.data.data.error) {
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("error")
                                // setFile([]);
                                // setProblemName("");
                                setEDA(false);
                                setFileProcessCompleted(false);
                                setTargetVariables([]);
                                setColumnCount(0);
                                setRowCount(0);
                                setDroppedColumnsData([]);
                                setEda_report_msg("")
                                setIsEDAReportAvailable(false);
                            } else {
                                setTargetVariables(statusResponse.data.data.target_variables);
                                setColumnCount(statusResponse.data.data.count_dropped_columns);
                                setDroppedColumnsData(statusResponse.data.data.dropped_columns);
                                setEda_report_msg(statusResponse?.data?.data?.eda_report_msg);
                                setRowCount(statusResponse.data.data.dropped_rows)
                                setIsEDAReportAvailable(statusResponse.data.data.report_generated);

                                setSnackbarMsg("File processed and uploaded successfully")
                                setSeverityType("success")

                            }


                            setLoadpen(false)
                            setSnackbarOpen(true)

                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {
                        const errorMessage = error.response?.data?.message || 'Something went wrong';
                        console.error(errorMessage);
                        setLoadpen(false)

                        setSnackbarMsg(errorMessage)
                        setSeverityType("error")
                        setSnackbarOpen(true)

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                setSnackbarMsg('Error: Unable to process and store the file')
                setSnackbarOpen(true)

                throw new Error('Error: Unable to process and store the file');
                // setTimeout(checkUploadStatus, 2000);
            }

        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Something went wrong';
            console.log("status code : ", error.response?.data?.status)
            console.log(errorMessage)
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        }

    }

    const getPresignedurl = async () => {
        setLoadpen(true)
        setSnackbarOpen(false)
        try {
        const uploadPromises = file.map(async (currentFile, index) => {
            const filename = currentFile.name;
            const problemname = problemName;
            const payload = {
                filename,
                problemname
            }

            const presignedResponse = await fetchAPI.post('/pre_signed_url', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            const { fields, url, actual_name } = presignedResponse.data;

            const formData = new FormData();
            for (const [key, value] of Object.entries(fields)) {
                formData.append(key, value);
            }

            formData.append("file", currentFile);

            const uploadResponse = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (uploadResponse.status === 204 || uploadResponse.status === 200) {
                console.log(`File ${filename} uploaded successfully to S3`);
                return fields.key; // Return the key for this file
            } else {
                throw new Error(`Error uploading file ${filename} to S3`);
            }
        });

        const uploadedKeys = await Promise.all(uploadPromises);
        
        setKey(uploadedKeys);
        handleFileUpload(uploadedKeys);

    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Something went wrong';
        setLoadpen(false)
        setSnackbarMsg(errorMessage)
        setSeverityType("error")
        setSnackbarOpen(true)
    }
}

    const handleEDA = (event) => {
        setEDA(event.target.checked)

    }

    const handleProblemName = (event) => {
        setProblemName(event.target.value)
        setErrorField(event.target.value.includes('_'));

    }

    const handleModalOpen = () => setModalOpen(true);
    const handleModalClose = () => setModalOpen(false);

    const downloadEDAReport = async () => {
        setLoadpen(true)
        const payload = {
            problemName
        }

        try {
            const presignedResponse = await fetchAPI.post('/eda_pre_signed_url', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            if (presignedResponse.status === 204 || presignedResponse.status === 200) {
                console.log(presignedResponse.data.url)

                if (presignedResponse.data) {
                    // window.location.assign(presignedResponse.data.url);
                    const downloadUrl = presignedResponse.data.url
                    const fileName = presignedResponse.data.fileName

                    const fileResponse = await fetch(downloadUrl);
                    const blob = await fileResponse.blob();

                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName); // Suggests filename
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(blobUrl);


                } else {
                    console.error("Error fetching pre-singed url. ")

                }

            } else {
                console.error("Unexpected response status:", presignedResponse.status);

            }
            setLoadpen(false)

        } catch (error) {
            console.error('Error while downloading the file:', error);

            const errorMessage = error.response?.data?.message || 'Something went wrong';
            console.error('Error while downloading the file:', errorMessage);

            setSnackbarMsg(errorMessage);
            setSeverityType("error");
            setSnackbarOpen(true)
            setLoadpen(false)
        }

    }

    return (
        <>
            <Card variant="outlined" sx={[cardStyle]}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={cardHeader}>Data uploading and pre-processing</Typography>

                    {/* <span> <Switch onChange={handleEDA} checked={EDA}></Switch> Generate EDA Report</span> */}

                </Grid>

                <Box sx={{ width: '100%' }}>
                    {/* Row 1: Input 1 + Switch */}
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                        mb={3}
                    >
                        <FormControl sx={{ flex: '1 1 65%', minWidth: 250 }}>
                            <TextField
                                helperText={errorField ? "Underscores are not allowed" : ""}
                                error={Boolean(errorField)} id="outlined-basic"
                                label="Problem name"
                                variant="outlined"
                                onChange={handleProblemName}
                                value={problemName}
                            />

                        </FormControl>

                        <Card variant="outlined" sx={[{
                            flex: '1 1 30%',
                            minWidth: 150,
                            display: 'flex',
                            alignItems: 'center',
                            // marginTop: "12px",
                            // padding: "20px",
                            paddingLeft: "20px",
                            borderRadius: "20px",
                            border: "0px",
                            boxShadow: "0 1px 4px rgba(133, 146, 173, .2)",
                            backgroundColor: "#f8fafd"
                        }]}>
                            <span style={{ fontWeight: "bold" }}>
                                Generate EDA report
                                <Switch onChange={handleEDA} checked={EDA}></Switch>
                                {EDA ? <span style={{ fontWeight: "normal", fontSize: "small", color: "gray" }}> Estimated upload time: 2 minutes </span> : null}</span>

                        </Card>

                    </Box>

                    {/* Row 2: Input 2 + Button */}
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >

                        <FormControl sx={{ flex: '1 1 65%', minWidth: 250 }}>
                            <FileUploadField
                                textfieldProps={{ label: "Upload the excel file" }}
                                files={file}
                                setFiles={setFile}
                                multiple={true} />
                        </FormControl>

                        <Button disabled={errorField || file.length===0 || !problemName.trim()} fullWidth variant="contained" sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={getPresignedurl}> <span><CloudUploadIcon sx={iconStyle} /></span><span>Upload</span></Button>

                    </Box>
                </Box>



            </Card>

            {fileProcessCompleted ?
                <Card variant="outlined" sx={[cardStyle]}>
                    <Box >
                        <UploadFileDetails columnCount={columnCount} droppedColumnsData={droppedColumnsData} rowCount={rowCount} isEDAReportAvailable={isEDAReportAvailable} downloadEDAReport={downloadEDAReport} eda_report_msg={eda_report_msg} />
                    </Box>

                </Card>
                : null}


            {fileProcessCompleted ?
            <Card variant="outlined" sx={[cardStyle]}>
                <Grid >
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={[cardHeader, { marginBottom: "auto", marginTop: "auto" }]}>
                            Select problem formulation inputs (geometry and boundary condition) and outputs (target variables)
                            
                                
                            {/* <InfoIcon sx={icons} onClick={handleModalOpen} /> */}
                        </Typography>

                        

                    </Grid>
                    <Grid sx={{ display: "flex" }} container spacing={2}>

                        <MultiDropDown ref={grandchildRef} data={targetVariables} problemName={problemName} />


                    </Grid>

                </Grid>

            </Card> : null}



            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>

            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalstyle}>
                    <UploadFileDetails columnCount={columnCount} droppedColumnsData={droppedColumnsData} rowCount={rowCount} />


                </Box>
            </Modal>

            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />

        </>
    )
}
)